import React from "react";
import GhostBar from "./GhostBar";

const GhostCommentCard = () => {
  return (
    <div className="comment-card-item" style={{ cursor: "default" }}>
      {/* Skeleton Avatar */}
      <GhostBar
        width="36px"
        height="36px"
        circle
        className="comment-user-avatar"
      />

      {/* Skeleton Details Container */}
      <div className="comment-details-container" style={{ width: "100%" }}>
        {/* Meta Header: Author name + Date */}
        <div className="comment-meta-header" style={{ alignItems: "center" }}>
          <GhostBar width="100px" height="14px" />
          <GhostBar width="60px" height="10px" />
        </div>

        {/* Comment Text Body Skeleton (2 lines) */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "6px",
            margin: "8px 0",
          }}
        >
          <GhostBar width="90%" height="12px" />
          <GhostBar width="60%" height="12px" />
        </div>

        {/* Reactions Container Skeleton */}
        <div className="reactions-comments-container">
          <GhostBar
            width="40px"
            height="18px"
            style={{ borderRadius: "12px" }}
          />
          <GhostBar
            width="40px"
            height="18px"
            style={{ borderRadius: "12px" }}
          />
        </div>
      </div>
    </div>
  );
};

export default GhostCommentCard;
